import cx from 'classnames';
import { useFormControlContext } from './useFormControl';
import { DetailedHTMLProps, TextareaHTMLAttributes } from 'react';
export interface IFormControlTextareaProps
  extends DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  variant?: 'rio' | 'default';
}

export const FormControlTextarea = (props: IFormControlTextareaProps) => {
  const { className, disabled, variant, ...restProps } = props;

  const { readOnly } = useFormControlContext() || {};

  return (
    <textarea
      disabled={disabled || readOnly}
      className={cx('slds-input resize-vertical', className, {
        'rio-textarea': variant === 'rio'
      })}
      style={readOnly ? { backgroundColor: '#aaa' } : {}}
      {...restProps}
    />
  );
};
